mainApp.component('socketFrontIllustration', {
    templateUrl: '/public/components/socket-front-illustration.component.html',
    bindings: {
        socketSettings: '<'
    },
    controller: socketFrontIllustrationController
});

function socketFrontIllustrationController() {
    var ctrl = this;

};

